import { getUtmValues } from './utils/getUtmValues';

const pStyle = {
  fontSize: '90%',
  margin: 0,
  color: '#696971',
  textAlign: 'left',
};

const iconStyles = {
  display: 'inline-block',
  paddingRight: 16,
};

const Preview = (props) => {
  const { name, position, pronouns, showSocialMedia = false } = props;
  return (
    <table
      role="presentation"
      cellSpacing="0"
      cellPadding="0"
      border="0"
      align="left"
    >
      <tbody>
        <tr>
          <td style={{ width: 64, verticalAlign: 'middle' }}>
            <img
              style={{ width: 64, height: 64 }}
              src="https://storage.googleapis.com/assets.cdn.staging.feather-insurance.com/assets/logo-orange-box.png"
              alt="Feather logo"
            />
          </td>
          <td style={{ paddingLeft: 24, lineHeight: '1.5em' }}>
            <p
              style={{
                fontSize: '110%',
                margin: 0,
              }}
            >
              {name || 'John Doe'}
              {pronouns && (
                <span style={{ marginLeft: 6, fontSize: '90%' }}>
                  ({pronouns})
                </span>
              )}
            </p>
            <p style={pStyle}>{position || 'Marketing'}</p>
            <a
              href={`https://www.feather-insurance.com?${getUtmValues(name)}`}
              style={pStyle}
            >
              feather-insurance.com
            </a>
          </td>
        </tr>
        {showSocialMedia && (
          <tr>
            <td />
            <td
              style={{
                fontSize: 0,
                wordBreak: 'break-word',
                paddingLeft: 24,
                paddingTop: 12
              }}
              align="left"
            >
              <a
                href="https://www.instagram.com/feather.insurance/"
                target="_blank"
                rel="noreferrer noopener"
                style={iconStyles}
              >
                <img
                  src="https://storage.googleapis.com/feather-email-assets/social-icons/instagram.png"
                  width="14"
                  height="14"
                  alt="instagram logo"
                />
              </a>
              <a
                href="https://www.facebook.com/featherinsurance/"
                target="_blank"
                rel="noreferrer noopener"
                style={iconStyles}
              >
                <img
                  src="https://storage.googleapis.com/feather-email-assets/social-icons/facebook.png"
                  width="14"
                  height="14"
                  alt="facebook logo"
                />
              </a>
              <a
                href="https://www.linkedin.com/company/feather-insurance"
                target="_blank"
                rel="noreferrer noopener"
                style={iconStyles}
              >
                <img
                  src="https://storage.googleapis.com/feather-email-assets/social-icons/linkedin.png"
                  width="14"
                  height="14"
                  alt="linkedin logo"
                />
              </a>
              <a
                href="https://twitter.com/hello_feather"
                target="_blank"
                rel="noreferrer noopener"
                style={iconStyles}
              >
                <img
                  src="https://storage.googleapis.com/feather-email-assets/social-icons/twitter.png"
                  width="14"
                  height="14"
                  alt="twitter logo"
                />
              </a>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default Preview;
